import { useEffect, useState } from 'react';
import { BasicContainer } from './BasicContainer';
import { Template } from '../Template';
import { ScenarioWrapper } from './ScenarioWrapper';
import { useTreeStore } from '@/frontend/store/TreeStore';
import { ContainerTreeObject } from '@/frontend/types/navigationTypes';
import { ParameterType, ParameterSubjectType } from '@/types/parameterTypes';
import { ParameterTable } from '../parameters/ParameterTable';
import { ContainerValidations } from '../validations/ContainerValidations';

export function Step(props: { initItem: ContainerTreeObject, parentShowCascade?: boolean }) {
  const { initItem, parentShowCascade } = props;
  const container = initItem.container;
  const [showStep, setShowStep] = useState<boolean>(parentShowCascade === undefined ? true : parentShowCascade);
  const updateContainer = useTreeStore(state => state.updateContainer);

  useEffect(() => {
    setShowStep(parentShowCascade === undefined ? true : parentShowCascade);
  }, [parentShowCascade]);

  const collapsedClass = showStep ? '' : 'border-bottom-0';

  return (
    <div id={initItem.id} className="card bg-light border border-dark-subtle observed-element mt-2">
      <div className={`card-header bg-body-secondary ${collapsedClass}`} data-testid='step-item-header'>
        <BasicContainer container={container} showSection={showStep} setShowSection={setShowStep} />
        { container.isScaffold && showStep &&
          <Template initItem={container} updateItem={(updatedContainer) => updateContainer({ container: updatedContainer })} />
        }
      </div>
      { showStep && <>
        <div className="card-body">
          <ParameterTable subjectId={container.id} parameterType={ParameterType.INPUT} subjectType={ParameterSubjectType.STEP} />
          <div className='pt-2' ><ScenarioWrapper stepNode={initItem} /></div>
        </div>
        <div className="card-footer bg-body-secondary">
          <ContainerValidations subjectId={container.id} />
          <ParameterTable subjectId={container.id} parameterType={ParameterType.OUTPUT} subjectType={ParameterSubjectType.STEP} />
        </div>
      </> }
    </div>
  );
}
